export const Events = {
		UPDATE_LIST_USERS_ADMIN: 'UPDATE_LIST_USERS_ADMIN',
		UPDATE_LIST_USERS_AUTHORIZERS: 'UPDATE_LIST_USERS_AUTHORIZERS',
		UPDATE_LIST_USERS_BUSINESS_ASSISTANTS: 'UPDATE_LIST_USERS_BUSINESS_ASSISTANTS',
		UPDATE_LIST_USERS_COMMERCIAL_DIRECTORS: 'UPDATE_LIST_USERS_COMMERCIAL_DIRECTORS',
		UPDATE_LIST_USERS_COMMERCIAL: 'UPDATE_LIST_USERS_COMMERCIAL',
		UPDATE_LIST_ACCOUNTS: 'UPDATE_LIST_ACCOUNTS',
}
